import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import {
  Option,
  Radios as SelectedComponent,
} from 'components/Form/Radios/index';

interface RadiosFormWrapperProps<T extends string | number>
  extends FieldRenderProps<T> {
  options: Option<T>[];
  label?: string;
  className?: string;
}

export function Radios<T extends string | number>(
  props: RadiosFormWrapperProps<T>,
) {
  const { input, meta, ...rest } = props;
  return (
    <SelectedComponent
      value={input.value}
      onChange={input.onChange}
      {...rest}
    />
  );
}
